import { render, staticRenderFns } from "./StoreProductDetail.vue?vue&type=template&id=08640323&scoped=true&"
import script from "./StoreProductDetail.vue?vue&type=script&lang=js&"
export * from "./StoreProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08640323",
  null
  
)

export default component.exports